import _ from 'lodash';

import {convertForConsolidatedWorkspaces} from './convertForConsolidatedWorkspaces';
import {ROUTES as ROUTES_ALL} from './routes';
import {ROUTES_DATA as ROUTES_DATA_ALL} from './routesData';
import {RouteData} from './types';

export function makeRoutes(
  isWorkspaceConsolidationEnabled = false
): RouteData[] {
  const ROUTES = convertForConsolidatedWorkspaces(
    ROUTES_ALL,
    isWorkspaceConsolidationEnabled
  );
  const ROUTES_DATA = convertForConsolidatedWorkspaces(
    ROUTES_DATA_ALL,
    isWorkspaceConsolidationEnabled
  );

  // HAX: These checks ensure that the route mapping above is in sync with routes/routes.ts.
  // routes/routes.ts is shared between the main app and the host function.
  if (ROUTES_DATA.length !== ROUTES.length) {
    throw new Error(
      `mismatched routes length: ${ROUTES_DATA.length}, ${ROUTES.length}`
    );
  }
  for (let i = 0; i < ROUTES_DATA.length; i++) {
    const r = ROUTES_DATA[i];

    const rc = ROUTES[i];
    if (
      !_.isEqual(r.path, rc.path) ||
      ('redirect' in r && r.redirect !== rc.redirect) ||
      r.exact !== rc.exact
    ) {
      throw new Error(`mismatched routes: ${r.path}, ${rc.path}`);
    }
  }

  return ROUTES_DATA;
}
